// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill";
import Vue from "vue";
import App from "./App";
import router from "./router";
import { store } from "./vuex/index";
import "@/common/reset.css"; /*引入公共样式*/
import "@/common/iconfont/iconfont.css";
import * as filter from "./filter";
Object.keys(filter).forEach(key => {
  Vue.filter(key, filter[key]);
});
router.beforeEach((to, form, next) => {
  if (to.meta.title) {
    window.document.title = to.meta.title;
  } else {
    window.document.title = "国家海洋标准计量中心";
  }
  next();
});

router.afterEach((to, from) => {
  window.scroll(0, 0);
});
Vue.config.productionTip = false;

// var _hmt = _hmt || [];
// window._hmt = _hmt;
// (function() {
//   var hm = document.createElement("script");
//   hm.src = "https://hm.baidu.com/hm.js?b7ce3800df13458b647a711cf69e756f";
//   var s = document.getElementsByTagName("script")[0];
//   s.parentNode.insertBefore(hm, s);
// })();

/* eslint-disable no-new */
new Vue({
  el: "#app",
  store,
  router,
  components: {
    App
  },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js